<template>
  <div class="container clinic-categories">
    <clinic-show-category ref="showcategory" @submit="onSubmit"></clinic-show-category>
    <div class="row">
      <div class="col-sm-8">
        <h1 class="page-title">UNIDADES CLÍNICAS</h1>
      </div>
      <div class="col-sm-4 text-center">
        <button @click="addNewCategory" type="button" class="btn btn-wabident-round btn-block">
          <i class="fas fa-plus mr-2"></i> Nueva Unidad
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <table class="table category-search-results">
          <thead>
            <tr class="category-search-results__row">
              <th>NOMBRE</th>
              <th>CAT. SUPERIOR</th>
              <th>CODIGO</th>
            </tr>
          </thead>
          <tbody>
            <tr class="category-search-results__row" v-for="(category, id) in categories" :key="id"
              @click="categoryClicked(category)">
              <td>{{ category.prefix }} {{ category.name }}</td>
              <td>{{ parent_categories[category.parent_id] }}</td>
              <td>{{ category.slug }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      product_hierarchy: []
    }
  },
  computed: {
    categories() {
      let ret = [];

      this.product_hierarchy.forEach((cat) => {
        this.addCategory(cat, ret, 0);
      });

      return ret;
    },
    parent_categories() {
      let ret = {};
      ret[null] = '';

      this.categories.forEach((cat) => {
        ret[cat.id] = cat.name;
      });

      return ret;
    },
  },
  methods: {
    addCategory(cat, ret, level) {
      let prefix = '— '.repeat(level);

      ret.push({
        id: cat.id,
        slug: cat.slug,
        name: cat.name,
        parent_id: cat.parent_id,
        level: level,
        prefix: prefix,
      });

      cat.children.forEach((subcat) => {
        this.addCategory(subcat, ret, level + 1);
      });
    },
    onSubmit() {
      this.loadCategories();
    },
    addNewCategory() {
      this.$refs.showcategory.showNew();
    },
    categoryClicked(cat) {
      this.$refs.showcategory.showEdit(cat);
    },
    loadCategories() {
      axios
        .get("/product/hierarchy")
        .then((response) => {
          this.product_hierarchy = response.data;
        });
    },
  },
  mounted() {
    this.loadCategories();
  }
}
</script>

<style lang="scss">
.clinic-categories {
  margin-top: 52px;

  .page-title {
    font-size: 32px;
    color: var(--theme-text-color);
    letter-spacing: 0.5px;
    line-height: 1.31;
    font-weight: 800;
    margin-bottom: 27px;
  }


  .category-search-results {
    width: 100%;

    th {
      font-size: 15px;
      letter-spacing: 0.3px;
      color: var(--theme-grey);
      border: none;
      position: sticky;
      background-color: white;
      top: 0;
    }

    &__row {
      cursor: pointer;
      background-color: transparent;
      transition: all 0.2s;
      border: none;
      border-bottom: 1px #e0e0e0 solid;

      &:hover {
        background-color: var(--theme-highlight);
      }

      td {
        font-size: 16px;
        line-height: 20px;
        color: var(--theme-text-color);

        &.product-code,
        &.product-icon {
          color: var(--theme-grey);
          text-transform: uppercase;

          svg {
            fill: currentColor;
          }
        }
      }
    }
  }
}
</style>
